<div class="filter-for-list">
  <button type="button" class="btn top-list-tools" placement="left" ngbTooltip="Click here to add a new item"
          [routerLink]="'/project'" *ngIf="authenticationService.userHasRoleOsmos()">
    <fa-icon [icon]="iconService.faPlus"></fa-icon>
    {{'ADD_PROJECT'|translate}}
  </button>
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>
  <mat-slide-toggle class="sliderActiveList" (change)="reLoadList()" ngModel="activeProject" placement="right"
                    [ngbTooltip]="'PROJECT_ACTIVE_SLIDER_TOOLTIP' | translate">{{getActiveTextForSlider()}}
  </mat-slide-toggle>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="matTableDataSource" matSort class="table-striped" style="width:100%">

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.id}}</td>
  </ng-container>


  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
    <td mat-cell *matCellDef="let project">

      <mat-chip-list>
        <mat-chip class="selected">
          {{project.name}}
        </mat-chip>
      </mat-chip-list>

    </td>
  </ng-container>

  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'CODE'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <mat-chip-list>
        <mat-chip>
          {{project.code}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ADDRESS'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.address.place}} {{project.address.street}}
      {{project.address.zipcode}} {{project.address.city}} {{project.address.country}}
    </td>
  </ng-container>

  <ng-container matColumnDef="start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'START_DATE'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.start_date | date:'mediumDate': 'UTC'}}</td>
  </ng-container>

  <ng-container matColumnDef="end_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'END_DATE'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.end_date | date:'mediumDate': 'UTC'}}</td>
  </ng-container>

  <ng-container matColumnDef="archive">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ARCHIVE'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <fa-icon class="statusAbo"
               [ngbTooltip]="'ARCHIVE_TOOLTIP' | translate"
               [ngClass]="{'red' : !project.archive }"
               [icon]="getIconStatus()"></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="project_device_locations_count">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LOCATION'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <mat-chip-list>
        <mat-chip class="location">
          {{project.project_device_locations_count}}
        </mat-chip>
      </mat-chip-list>

    </td>
  </ng-container>

  <ng-container matColumnDef="project_device_assignements_count">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'SPCU'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <mat-chip-list>
        <mat-chip>
          {{project.spcu_count}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="bad_note">
    <th mat-header-cell *matHeaderCellDef>{{'PROJECTS_NOTATION' | translate}}</th>
    <td mat-cell *matCellDef="let project" class="notation">
      <mat-chip-list>
        <mat-chip class="location" *ngIf="project.note_project_users_current.note_litteral"
                  [ngStyle]="{backgroundColor: project.note_project_users_current.note_color}">
          {{project.note_project_users_current.note_litteral}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>


  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef width="312px">{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <div class="d-flex">
        <button type="button" class="btn list-tools" style="background: cornflowerblue  " placement="left"
                [ngbTooltip]="('HOME_PAGE' | translate)"
                [routerLink]="'/project-locations-map-plan/'+project.id">
          <fa-icon [icon]="iconService.faHome"></fa-icon>
        </button>
        <button type="button" placement="left"
                [ngbTooltip]="'READ_ICON_TOOLTIP' | translate" class="btn list-tools"
                [routerLink]="'/projects-view/'+project.id"
                *ngIf="authenticationService.userHasRoleOsmos()">
          <fa-icon [icon]="iconService.faEye"></fa-icon>
        </button>
        <button type="button" placement="left"
                [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate" class="btn list-tools"
                [routerLink]="'/projects/'+project.id"
                *ngIf="authenticationService.userHasRoleOsmos()">
          <fa-icon [icon]="iconService.faEdit"></fa-icon>
        </button>
        <button type="button" class="btn list-tools" style="background: orange "
                [routerLink]="'/project-alarms/'+project.id"
                *ngIf="authenticationService.userHasRoleOsmos()">
          <fa-icon [icon]="iconService.faBell"></fa-icon>
        </button>
        <button type="button" class="btn list-tools" style="background: orangered"
                [routerLink]="'/project-last-alarms/'+project.id" placement="left"
                [ngbTooltip]="'LAST_ALARM_TOOLTIP' | translate">
          <fa-icon [icon]="iconService.faExclamationTriangle"></fa-icon>
        </button>
        <button type="button" class="btn list-tools" style="background: darkgreen"
                (click)="openExportCsvModal(project.id, project.start_date, project.end_date)" placement="left"
                [ngbTooltip]="'CSV_EXPORT_TOOLTIP' | translate">
          <fa-icon [icon]="iconService.faFileExcel"></fa-icon>
        </button>

        <button type="button" class="btn list-tools" style="background: cornflowerblue"
                [routerLink]="'/chart/'+project.id" placement="left"
                [ngbTooltip]="'CHART_TOOLTIP' | translate">
          <fa-icon [icon]="iconService.faChartLine"></fa-icon>
        </button>
        <button type="button" class="btn list-tools eventdyn"
                [routerLink]="'/event-dyn/'+project.id" placement="left"
                [ngbTooltip]="'EVENTDYN_TOOLTIP' | translate"
                [disabled]="!project.project_status_third_party_data?.eventdyn_subscription_id">
          <fa-icon [icon]="iconService.faBolt"></fa-icon>
        </button>

        <button type="button" class="btn list-tools wimd"
                [routerLink]="'/project-wimd/'+project.id" placement="left"
                [ngbTooltip]="'WIM+D'"
                [disabled]="isNumber(project.project_wimd_subscription)">
          <fa-icon [icon]="iconService.faTruck"></fa-icon>
        </button>


        <button type="button" class="btn list-tools" style="background: hotpink"
                (click)="openLastMeasureModal(project.id)" placement="left"
                [ngbTooltip]="'LAST_MEASURE_TOOLTIP' | translate">
          <fa-icon [icon]="iconService.faClock"></fa-icon>
        </button>
        <button type="button" class="btn list-tools document"
                (click)="openLink(project?.document_url)" placement="left"
                [ngbTooltip]="'DOCUMENT_URL' | translate"
                [disabled]="!propertyExists(project?.document_url)">
          <fa-icon [icon]="iconService.faFolderOpen"></fa-icon>
        </button>

        <button type="button" class="btn list-tools" style="background: blueviolet"
                (click)="downloadDevicesAsCsv(project.id)" placement="left"
                [ngbTooltip]="'CSV_DEVICES_TOOLTIP' | translate"
                *ngIf="authenticationService.userHasRoleOsmos()">
          <fa-icon [icon]="iconService.faWrench"></fa-icon>
        </button>
        <!--        <button type="button" class="btn list-tools" style="background: crimson " placement="left"-->
        <!--                [ngbTooltip]="'TOOL_MENU_NOTES' | translate"-->
        <!--                [routerLink]="'/project-notations/'+project.id">-->
        <!--          <fa-icon [icon]="iconService.faGraduationCap"></fa-icon>-->
        <!--        </button>-->

        <!--        <button type="button" class="btn list-tools" style="background: cornflowerblue " placement="left"-->
        <!--                [ngbTooltip]="'TOOL_MENU_MAPS' | translate"-->
        <!--                [routerLink]="'/project-locations-map/'+project.id">-->
        <!--          <fa-icon [icon]="iconService.faGlobe"></fa-icon>-->
        <!--        </button>-->

        <!--        <button type="button" class="btn list-tools" style="background: #e91e63 " placement="left"-->
        <!--                [ngbTooltip]="'TOOL_MENU_PLANS' | translate"-->
        <!--                [routerLink]="'/project-locations-plan/'+project.id">-->
        <!--          <fa-icon [icon]="iconService.faMap"></fa-icon>-->
        <!--        </button>-->
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>


